import loadable from '@loadable/component';
import { WithConditionalHydration } from '../../../WithConditionalHydration';
import { domainService } from '../../../../domain/services/domainService';

const DrupalEditContentLoadable = loadable(
  () => import('./DrupalEditContent'),
  {
    resolveComponent: components => components.DrupalEditContent,
    ssr: false
  }
);

export const DrupalEditContent = WithConditionalHydration(
  DrupalEditContentLoadable,
  domainService.isRunningOnCMS
);
